/**
 * Moduł breadcrumbs
 *
 * @export
 * @class BreadcrumbsModule
 */
export class BreadcrumbsModule {
  /**
   * Czy ma być używany namespace
   *
   * @type {boolean}
   * @memberof BreadcrumbsModule
   */
  public namespaced: boolean = true;
  /**
   * Stan modułu
   *
   * @memberof BreadcrumbsModule
   */
  public state = {
    breadcrumbs: []
  };
  public mutations = {
    /**
     * Zapisuje breadcrumbs
     *
     * @param {*} localState
     * @param {*} breadcrumbs
     */
    set(localState: any, breadcrumbs: any) {
      localState.breadcrumbs = breadcrumbs;
    }
  };
}

export default new BreadcrumbsModule();
